
import TEditor from "@/components/TEditor/TEditor.vue";

import {
  DownloadOutlined,
  DownOutlined,
  QuestionCircleOutlined,
  PlusSquareOutlined,
  RedoOutlined,
  SearchOutlined,
  UploadOutlined,
  PlusOutlined,
  LoadingOutlined,
  UpOutlined,
} from "@ant-design/icons-vue";

import {Options, setup, Vue} from "vue-class-component";
import {computed, onUpdated, reactive, toRaw} from "vue";
import tokenService from "@/utils/tokenService";
import {message} from "ant-design-vue";

@Options({
  components: {
    SearchOutlined,
    RedoOutlined,
    DownOutlined,
    UpOutlined,
    PlusOutlined,
    QuestionCircleOutlined,
    PlusSquareOutlined,
    UploadOutlined,
    DownloadOutlined,
    LoadingOutlined,
    TEditor,
  },
  props: {
    form: {
      type: Object,
      default: {},
    },
    rules: {
      type: Object,
      default: {},
    },
    formConfig: {
      type: Object,
      default: {},
    },
    layoutConfig: {
      type: Object,
      default: {label: 5, wrapper: 18}
    },
  },
})
export default class EditOrAddForm extends Vue {
  editInfo = setup(() => {
    const docPrefix = process.env.VUE_APP_API_DOC_NGINX_URL;
    const cacheFileList = reactive<any>({});
    const cacheImageUrl = reactive<any>({});
    const cacheLoading = reactive<any>({});
    const {form, modalConfig, formConfig} = reactive<any>(this.$props);

    const imgHeader = {
      Authorization: tokenService.getToken(),
    };
    const imageParam = {
      fileType: 1,
      serviceId: 1,
    };
    //定义a-form实例变量
    let validateForm: any;

    const computedModalTitle = computed(() => {
      return (modalConfig.editFlag ? "编辑" : "新增") + modalConfig.modalName;
    })

    const getFileUploadUrl = () => {
      return process.env.VUE_APP_API_DOC_NORMAL_FILE_UPLOAD_URL;
    };
    const beforeUpload = (file: FileItem) => {
      const isJpgOrPng =
          file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
      }
      return isJpgOrPng && isLt2M;
    };
    const handleChange = (info: FileInfo, key: any) => {
      if (info.file.status === "uploading") {
        cacheLoading[key] = true;
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        let response: any = toRaw(info.file.response);
        cacheImageUrl[key] = docPrefix + response.data.relatePath;
        console.log('response.data.relatePath:',response.data.relatePath)
        console.log('cacheImageUrl',cacheImageUrl[key])
        cacheLoading[key] = false;
        setUploadImgUrl(key);
        console.log('form:',form)

      }
      if (info.file.status === "error") {
        cacheLoading[key] = false;
        message.error("upload error");
      }
    };
    const setUploadImgUrl = (formKey: string) => {
      let list = cacheFileList[formKey];
      if (list.length > 0 && list[list.length-1].uid != -1) {
        // alert(list)
        Reflect.set(form, formKey, list[list.length-1].response.data.relatePath);
      }
    };
    const onChange = (val: any, key: any) => {
      // console.log('onChange', val, key)
      Reflect.set(form, key, val);
    }
    const switchImgStatus = (checked: boolean, key: any) => {
      Reflect.set(form, key, checked ? 1 : 0);
    };
    const setValidateForm = (el: any) => {
      validateForm = el;
    }

    /**
     * 多选下拉框搜索功能，直接输入name就可以进行筛选
     * @param inputValue
     * @param option
     */
    const filterOption = (inputValue: any, option: any) => {
      return (option.children[0].children.indexOf(inputValue) >= 0)
    }
    const getCacheImageUrl = () => {

      for (const key in formConfig) {
        if (formConfig[key].type == 'image' && form[key] !== null) {
          Reflect.set(cacheImageUrl, key, docPrefix + form[key]);
        } else {
          Reflect.set(cacheImageUrl, key, null);
        }
      }
    }

    const getValidateForm = () => {
      if (validateForm) {
        return validateForm;
      } else {
        console.log('no validate')
      }
    }
    onUpdated(() => {
      getCacheImageUrl();
    })


    return {
      cacheFileList,
      imageParam,
      cacheImageUrl,
      imgHeader,
      computedModalTitle,
      validateForm,
      getFileUploadUrl,
      beforeUpload,
      handleChange,
      onChange,
      setValidateForm,
      switchImgStatus,
      filterOption,
      getValidateForm
    }
  });

}

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: string;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
